import { colorBrandPrimary } from 'src/global.style';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 80vh;
  background-color: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const ModalContainer = styled.div`
  height: 437px;
  width: 867px;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0 8px 24px 0 rgba(0,0,0,0.12), 0 0 1px 0 rgba(0,0,0,0.12);
  color: ${colorBrandPrimary.marine};
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    height: 58px;
    width: 140px;
    margin-top: 64px;
  }
`

export const Title = styled.h1`
  font-family: "Galano Grotesque Alt";
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 35.2px;
  margin-top: 56px;
`;

export const TextContent = styled.p`
  width: 611px;
  color: #110E49;
  font-family: "Open Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  margin-top: 32px;
`;
